import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackagesRewardsAndPayment } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { getRewardsAccounts } from "../../../rewards/reducer";
import { getTravelWalletOffers } from "../../../travel-wallet/reducer";
import { fetchTravelWalletDetails } from "../../../travel-wallet/actions/actions";

export const mapStateToProps = (state: IStoreState) => {
  return {
    rewardsAccounts: getRewardsAccounts(state),
    allWalletOffers: getTravelWalletOffers(state),
  };
};

export const mapDispatchToProps = {
  fetchTravelWalletDetails,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesRewardsAndPaymentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackagesRewardsAndPayment = withRouter(
  connector(PackagesRewardsAndPayment)
);
